<template>
  <v-dialog
    v-model="show"   
  >
    <v-card v-if="show">
      <v-card-title class="text-h5">
        Leveransinformation {{ paper.deliveryDate | longPaperDate }}
      </v-card-title>
      <v-card-text>
        {{ paper.message }}
      </v-card-text>
  
      <v-card-actions>
        <v-spacer />
  
        <v-btn
          color="info"          
          @click="$emit('close')"            
        >
          OK
        </v-btn>          
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogMixin from '@/components/web/dialogs/DialogMixin'

export default {
  name: 'DeliveryMessageDialog',
  mixins: [ DialogMixin ],
  props: {       
    paper: { type: Object, required: true }
  } 
}
</script>